import React from "react";

import { ProductEditContext } from "@v2/features/products/ProductEditContext";
import { useRequiredContext } from "replo-utils/react/context";

export function useProductFormEdit() {
  return useRequiredContext(ProductEditContext);
}
